import { createReducer } from 'helpers/ReducerUtil'
import {
  UPDATE_VALUE,
} from './constants'

const updateValue = (values, action) => {
  const { value } = action
  if (isNaN(value))
    return values
  else
    return [{ value }]
}

const sliderReducer = createReducer([], {
  [UPDATE_VALUE]: updateValue
})

export default sliderReducer
